import { useQuery } from "@tanstack/react-query";

import { weldLengthQuery } from "../infra/weldLength.query";

export const useWeldLength = (id: string | undefined) => {
  const { data, ...rest } = useQuery({
    ...weldLengthQuery(id),
    enabled: !!id,
  });

  return { weldLength: data?.weldLength ?? null, ...rest };
};
